import { Component, Input, OnInit } from '@angular/core';

import { Sizes } from '../../../shared/enums';
import { IBadge } from '../../badge/interfaces';

@Component({
    selector: 'cmn-button',
    templateUrl: './button.component.html',
    styleUrls: [ './button.component.scss' ],
})

export class ButtonComponent implements OnInit {
    @Input() public readonly size: Sizes;
    @Input() public readonly badge: IBadge;
    @Input() public readonly label: string;
    @Input() public readonly leftIcon: string;
    @Input() public readonly rightIcon: string;
    @Input() public readonly isLoading: boolean;
    @Input() public readonly isOutlined: boolean;
    @Input() public readonly isDisabled: boolean;
    @Input('class') public readonly clazz: string;
    @Input() public readonly type: string = 'button';

    public sizeIcon: string;

    public ngOnInit(): void {}
}
